import CloudSyncIcon from './cloud-sync-icon';
export default CloudSyncIcon;
